function isDateOnlyLike(value: unknown): value is { year: number; month: number; day: number } {
  return (
    typeof value === 'object' &&
    value !== null &&
    'year' in value &&
    'month' in value &&
    'day' in value &&
    typeof value.year === 'number' &&
    typeof value.month === 'number' &&
    typeof value.day === 'number'
  )
}

function toComparableDate(value: unknown, includeTime: boolean): Date | null {
  if (value === null || value === undefined || value === '') {
    return null
  }

  let date: Date

  if (value instanceof Date) {
    date = new Date(value)
  } else if (isDateOnlyLike(value)) {
    date = new Date(value.year, value.month - 1, value.day)
  } else if (typeof value === 'string') {
    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
    date = dateOnlyMatch
      ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]))
      : new Date(value)
  } else {
    date = new Date(String(value))
  }

  if (Number.isNaN(date.getTime())) {
    return null
  }

  if (!includeTime) {
    date.setHours(0, 0, 0, 0)
  }

  return date
}

function dateComparator(filterDate: Date, cellValue: unknown, includeTime: boolean): -1 | 0 | 1 {
  const cellDate = toComparableDate(cellValue, includeTime)

  if (!cellDate) {
    return 0
  }

  const filterTime = includeTime
    ? filterDate.getTime()
    : new Date(filterDate).setHours(0, 0, 0, 0)
  const cellTime = cellDate.getTime()

  if (cellTime < filterTime) { return -1 }
  if (cellTime > filterTime) { return 1 }
  return 0
}

export const textFilterParams = {
  maxNumConditions: 1,
  filterOptions: ['contains'],
  buttons: ['apply', 'reset'],
}

export const textFilterExactParams = {
  maxNumConditions: 1,
  filterOptions: ['equals'],
  buttons: ['apply', 'reset'],
}

export const dateFilterParams = {
  comparator: (filterDate: Date, cellValue: unknown): -1 | 0 | 1 =>
    dateComparator(filterDate, cellValue, false),
  includeTime: false,
  maxNumConditions: 1,
  filterOptions: ['inRange', 'equals'],
  inRangeInclusive: true,
  buttons: ['apply', 'reset'],
}

export const dateTimeFilterParams = {
  comparator: (filterDate: Date, cellValue: unknown): -1 | 0 | 1 =>
    dateComparator(filterDate, cellValue, true),
  includeTime: true,
  maxNumConditions: 1,
  filterOptions: ['inRange', 'equals'],
  inRangeInclusive: true,
  buttons: ['apply', 'reset'],
}

export const numberFilterParams = {
  maxNumConditions: 1,
  filterOptions: ['equals', 'greaterThan', 'lessThan', 'inRange'],
  buttons: ['apply', 'reset'],
}

export const setFilterParams = {
  buttons: ['apply', 'reset'],
}
